import { utils } from '../utils/utils';

class WixStoreApi {
  constructor() {
    this.connectedProvidersCache = null;
    this.galleryDataPromise = null;
  }

  initializePromises() {
    return new Promise((resolve, reject) => {
      var gallerySettingsPromise = this.sendRequest('GET', 'gallery/' + window['galleryId'], null);
      var storeGalleryDataPromise = this.getStoreGalleryData();
      var storeProvidersPromise = this.getProviders();

      Promise.all([gallerySettingsPromise, storeGalleryDataPromise, storeProvidersPromise])
        .then((results) => {
          resolve({
            gallerySettings: results[0],
            storeGalleryData: results[1],
            storeProviders: results[2].providers,
          });
        });
    });
  }

  getStoreGalleryData() {
    let returnPromise = null;
    const connectedProviders = window['connectedProviders'];
    if (!this.connectedProvidersCache && this.galleryDataPromise) {
      return this.galleryDataPromise;
    } else if (this.connectedProvidersCache) {
      this.galleryDataPromise = Promise.resolve(this.connectedProvidersCache);
    } else if (connectedProviders && typeof connectedProviders === 'object' && Object.keys(connectedProviders).length) {
      this.connectedProvidersCache = { connectedProviders };
      this.galleryDataPromise = Promise.resolve(this.connectedProvidersCache);
    } else {
      this.galleryDataPromise = new Promise((resolve, reject) => {
        this.sendRequest('GET', 'gallery/' + window['instanceId'] + '/providers', null)
          .then(response => {
            this.connectedProvidersCache = response;
            resolve(this.connectedProvidersCache);
          })
          .fail(reject);
      });
    }

    return this.galleryDataPromise;
  }

  connectProvider(providerId) {
    return new Promise((resolve, reject) => {
      this.sendRequest('POST', 'providers/' + providerId + '/connect', null).then((result) => {
        this.getProviders().then( (providersData) => {
          if (providersData && Array.isArray(providersData.providers)) {
            const providersList = providersData.providers;
            const connectedProvider = providersList.find(providerData => providerData.providerId === providerId);
            if (connectedProvider) {
              resolve({ result, providers: providersData });
            } else {
              reject();
            }
          } else {
            reject();
          }
        });
      });
    });
  }

  getProviders() {
    return this.sendRequest('GET', 'providers', null)
      .then((response) => {
        window['providers'] = response.providers;
        return response;
      });
  }

  sendRequest(type, endpoint, data) {
    let url = new window['URI'](window.location.protocol + '//progallery.wix.com/editor/api/v1/' + endpoint)
      .search({
        instance: window['instance'],
        locale: window['locale'],
        deviceType: 'desktop',
        cachekiller: new Date()
          .getTime(),
        isStore: true
      });

    return $.ajax({
      type: type,
      url: url.toString(),
      data: data,
      contentType: 'application/json',
      xhrFields: {
        withCredentials: true
      },
    });
  }

  openDashboard(options = {}) {
    const { title } = options;
    const objAdditionalParams = this.getProviderUrlOptions(options);
    var url = utils.generateUrl('store-dashboard.html', objAdditionalParams);
    Wix.Settings.openModal(url, '100%', '100%', title, _.noop, false, { overlay: 'rgba(0,0,0,0)', background: 'rgba(0,0,0,0)', margin: '0px 0px 0px 0px', padding: false });
  }

  openProviderModal(name, options = {}, containerParams = {}) {
    return new Promise((resolve, reject) => {
      if (name) {
        this.getStoreGalleryData()
          .then(({ connectedProviders }) => {
            const providerData = connectedProviders[Object.keys(connectedProviders)[0]];
            const { widgets } = providerData;

            if (widgets[name]) {
              const objAdditionalParams = this.getProviderUrlOptions(options);

              const finalParams = Object.assign({ name }, objAdditionalParams, containerParams);
              const providerModalUrl = utils.getProviderModalUrl(finalParams);
              Wix.openPopup(providerModalUrl, '100%', '100%', {
                origin: Wix.WindowOrigin.FIXED,
                placement: Wix.WindowPlacement.CENTER
              }, function onProviderModalClose() {
                console.log('Provider modal closed');
              }, Wix.Theme.BARE);
              resolve();
            } else {
              reject('Name does not exist in widgets');
            }
          })
          .catch(reject);
      } else {
        reject('Name not defined');
      }
    });
  }

  getProviderUrlOptions(options = {}) {
    const { urlParams, urlPath } = options;
    let objAdditionalParams = { urlParams: '{}', urlPath: '/' };
    if (urlParams && typeof urlParams === 'object') {
      const encodedParams = JSON.stringify(urlParams);
      objAdditionalParams.urlParams = encodedParams;
    }
    if (urlPath && typeof urlPath === 'string') {
      objAdditionalParams.urlPath = urlPath;
    }

    return objAdditionalParams;
  }
}

const storeApi = new WixStoreApi();

window.WixStoreApi = storeApi;

export default storeApi;



// WEBPACK FOOTER //
// ./store/storeApi.js